// extracted by mini-css-extract-plugin
export default {"container":"style__container--bvOLa","title":"style__title--zJwyz","tag":"style__tag--C42BC"};